import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import icoback from '../img/ico-back.svg';
import icobackblue from '../img/ico-backblue.svg';
import icosearch from '../img/ico-search.svg';
import icoclose from '../img/ico-close.svg';
import strings from '../strings.js'
import SongCard from '../SongCard';
import SelectingYesNoCard from '../SelectingYesNoCard';
import heart from '../img/heart.svg';
import noheart from '../img/noheart.svg';
import { SendMessage } from '../App.js';
import localForage from "localforage";
import homeLogoBg from '../img2026/homeLogoBg.jpg';

const API_URL = "https://www.starboxkod.com/api";

const song1 = {
    "song_num": 110108,
    "song_name": "给我多一点",
    "singer": "SHE",
    "language": "国语",
    "server_id": "C",
    "rel_path": "05\\110108"
}





export function Favourites({stateVer, lang, selectingYesNo, tableNo, setSelectedSinger, cookieFavs, setCookieFavs}) {

    const [searchTerm, setSearchTerm] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [searchLang, setSearchLang] = useState("language")


    function refreshFavs() {
        //setSongs(cookieFavs);
    }

    const observer = useRef()
    const lastSongElementRef = useCallback(node => {
        return
    })
    

    useEffect(() => {
        setPageNumber(0)
        document.getElementById("song-container").scrollTop =0;
      }, [searchTerm, searchLang])

    const [selectinddddgYesNo, setSelectingYesNo] = useState(false);
    const [selectingYesNoSong, setSelectingYesNoSong] = useState({});
    function nowSelectSong ({ song }) {
        //check if it's empty, if so then intialise
        navigate("/home/fav/select")
        console.log(cookieFavs);
        setSelectingYesNoSong(song);
    }

    
    const navigate = useNavigate()

    return (<>
    <div className="heatder purple">
        <a onClick={(e) => {e.preventDefault(); navigate(-1)}}>
        <img
            src={icoback}
            alt="home"           
        />
        </a>
        <div className = "headerReplaceText">{lang ? strings.cn.fav : strings.en.fav}</div>
        <div className = "headerEndText">{cookieFavs.length}</div>


    </div>

    <div className="song-container" id="song-container" style={{marginTop: "4rem"}}>
    {cookieFavs?.length > 0
        ? (
            <>
                {cookieFavs.map((song) => {
                    return <SongCard  setSelectedSinger={setSelectedSinger}   mode={2} song={song} key={song.song_num} lang={lang} onClick={() => { nowSelectSong({song});}} onClick2={() => { refreshFavs(); }}/>
                })}     
            </>
        ) :
        (
            <div className="empty">
                <h2>No songs found</h2>
            </div>
        )}


    </div>
    { selectingYesNo && (
        <>
        <SelectingYesNoCard cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} song={selectingYesNoSong} onClick={() => { navigate(-1); refreshFavs();}} stateVer={stateVer} lang={lang} tableNo={tableNo}/>
        </>
    )}
    
</>)}
